import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  space3XL,
  spaceL,
  spaceM,
  spaceS,
  spaceXL,
  spaceXS,
  spaceXXL,
  xdlColorText,
} from '@xing-com/tokens';
import { BodyCopy, Headline, Meta } from '@xing-com/typography';

const ArticleAuthorProfileWrapper = styled.div`
  margin-bottom: ${space3XL};

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${spaceXXL};
  }
`;

const ArticleAuthorProfileContainer = styled.div`
  display: flex;
  gap: ${spaceL};

  @media ${mediaSmallOrTiny} {
    flex-direction: column;
    gap: ${spaceS};
  }
`;

const ArticleAuthorInfoContainer = styled.div`
  display: flex;
  flex: 1;
  gap: ${spaceXL};

  @media ${mediaSmallOrTiny} {
    gap: ${spaceL};
  }
`;

const ArticleAuthorInfoContentContainer = styled.div`
  flex: 1;
`;

const ArticleAuthorTitle = styled(Headline)`
  display: flex;
  align-items: center;
  margin-bottom: ${spaceXS};

  & > span {
    margin-right: ${spaceM};
  }
`;

const ArticleAuthorTagline = styled(BodyCopy)`
  margin-bottom: ${spaceXS};
`;

const ArticleAuthorPublishedAtMeta = styled(Meta)`
  margin: ${spaceL} 0 ${spaceXL};
`;

const ArticleAuthorLink = styled.a`
  color: ${xdlColorText};
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;

const ArticleAuthorButton = styled(Button)`
  @media ${mediaSmallOrTiny} {
    width: 100%;
  }
`;

export const Styled = {
  ArticleAuthorProfileWrapper,
  ArticleAuthorProfileContainer,
  ArticleAuthorInfoContainer,
  ArticleAuthorInfoContentContainer,
  ArticleAuthorTitle,
  ArticleAuthorTagline,
  ArticleAuthorPublishedAtMeta,
  ArticleAuthorLink,
  ArticleAuthorButton,
};
